<template>
  <v-dialog
    v-model="show"
    width="650px"
    content-class="rounded-xl"
  >
    <v-card rounded="xl">
      <v-card-title>
        Редактирование факта выполнения
      </v-card-title>
      <v-form ref="editFactForm">
        <v-card-text>
          <v-card
            v-if="isToggleContract && !isPublication"
            flat outlined rounded="xl" class="mb-5"
          >
            <v-card-text>
              <div class="text-subtitle-1">{{ contract.eff_contract.plan_description }}</div>
              <v-radio-group
                v-model="payloadEdit.fact"
                row
              >
                <v-radio
                  label="Да"
                  value="Да"
                  color="teal darken-3"
                ></v-radio>
                <v-radio
                  label="Нет"
                  value="Нет"
                  color="teal darken-3"
                ></v-radio>
              </v-radio-group>
            </v-card-text>
          </v-card>

         <v-text-field
           v-else-if="!isPublication && !isToggleContract"
           v-model="payloadEdit.fact"
           outlined
           class="rounded-xl"
           label="Факт"
           color="teal darken-3"
           :rules="textFieldRules"
         />

          <v-text-field
            v-else
            v-model="payloadEdit.author"
            outlined
            class="rounded-xl"
            label="Автор"
            color="teal darken-3"
            :rules="textFieldRules"
          />

        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            @click="show=false"
            elevation="0"
            outlined
            class="rounded-xl"
            color="teal darken-3"
          >
            Отмена
          </v-btn>
          <v-btn
            @click="saveForm"
            color="teal darken-3"
            elevation="0"
            class="rounded-xl white--text"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TheEditFactContractDialog",

  props: {
    visible: Boolean,
    contract: Object,
  },

  data() {
    return {
      dialog: true,
      payloadEdit: {
        author: "",
        fact: "",
      },
      textFieldRules: [
        v => !!v || 'Обязательное поле.',
      ],
    }
  },

  watch: {
    'payloadEdit.author': function () {
      if (this.isPublication) {
        if (this.payloadEdit.author === 0 || this.payloadEdit.author === "0") return this.payloadEdit.fact = "0"
        this.payloadEdit.fact = (1/Number(this.payloadEdit.author)).toFixed(2).toString();
      }
    },
  },

  computed: {

    show: {
      get () {
        this.payloadEdit.fact = this.contract.fact;
        this.payloadEdit.author = this.contract.author;
        return this.visible
      },
      set (value) {
        if (!value) {
          this.reloadData();
          this.$emit('close')
        }
      }
    },

    isPublication() {
      return this.contract?.eff_contract?.is_publication;
    },

    isToggleContract() {
      return this.contract?.eff_contract?.indicator_name === "Обеспечение соотношения численности числа ППС и обучающихся очной формы обучения";
    }


  },

  methods: {
    reloadData() {
      this.payloadEdit.author = "";
      this.payloadEdit.fact = "";
    },

    saveForm() {
      if(this.$refs.editFactForm.validate()) {
        this.$emit('save', this.payloadEdit);
        this.$refs.editFactForm.resetValidation();
      }
    },
  }
}
</script>

<style scoped>

</style>